import { AdminPanelSettings, Person } from '@mui/icons-material';
import NoAccountsIcon from '@mui/icons-material/NoAccounts';
import { Divider, Grid, Menu, MenuItem } from '@mui/material';
import { HSpacer, RoutalSearchInput } from '@nx-smartmonkey/ui';
import { debounce } from 'lodash';
import { useState } from 'react';

import UserSearchIcon from '../../../assets/svg/left-bar/UserSearchIcon';
import * as routing from '../../../constants/Routing';
import { useAsUser } from '../../../hooks/session/useAsUser';
import { useSearchUsers } from '../../../hooks/sideBar/useSearchUsers';
import { useRetrieveUser } from '../../../hooks/user/useRetrieveUser';
import Text from '../../../react-components/Text';
import SideBarMenuItemContainer from './SideBarMenuItemContainer';

type SideBarUserSearchContextAnchor = {
  screenPosition: { top: number; left: number };
};

export const SideBarUserSearch = () => {
  const [isHover, setHover] = useState<boolean>(false);
  const { data: user } = useRetrieveUser();
  const { asUser, deleteAsUser, beAsUser } = useAsUser();
  const [searchText, setSearchText] = useState(``);
  const { data: users } = useSearchUsers({ text: searchText });
  const [userAnchorPosition, setUserAnchorPosition] = useState<SideBarUserSearchContextAnchor | undefined>(undefined);

  return (
    <>
      {(user?.isRoot() || asUser) && (
        <>
          <SideBarMenuItemContainer
            onClick={(ev: any) => {
              const boundingClient = ev.currentTarget.getBoundingClientRect();
              setUserAnchorPosition({
                screenPosition: { top: boundingClient.top - (asUser ? 200 : 160), left: boundingClient.left + 62 },
              });
            }}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
          >
            <UserSearchIcon isHover={isHover} color={asUser && `tomato`} />
          </SideBarMenuItemContainer>

          <Menu
            id="user-actions"
            anchorPosition={userAnchorPosition?.screenPosition}
            anchorReference="anchorPosition"
            open={Boolean(userAnchorPosition)}
            onClose={(_e) => setUserAnchorPosition(undefined)}
            disableAutoFocusItem
            autoFocus={false}
          >
            <Grid
              container
              style={{ height: asUser ? `240px` : `200px`, width: `340px`, position: `relative` }}
              direction="column"
            >
              <Grid
                container
                wrap="nowrap"
                item
                direction="column"
                style={{ height: `calc(100% - 38px)`, overflowY: `auto` }}
              >
                {asUser && (
                  <>
                    <MenuItem
                      style={{ padding: `4px 12px`, height: `38px`, minHeight: `38px` }}
                      onClick={() => {
                        deleteAsUser();
                        window.open(`${window.location.origin}${routing.BACKOFFICE.CLIENTS.USERS}`, `_self`);
                      }}
                    >
                      <NoAccountsIcon />
                      <HSpacer small />
                      <Text style={{ cursor: `pointer` }}>Back to root</Text>
                    </MenuItem>
                    <Divider />
                  </>
                )}
                {users?.docs.map((currentUser) => (
                  <MenuItem
                    style={{ padding: `4px 12px`, height: `38px`, minHeight: `38px` }}
                    onClick={() => {
                      beAsUser({ id: currentUser.id });
                      window.open(routing.PLANNER.ROOT, `_self`);
                    }}
                    disabled={currentUser.id === user?.id}
                  >
                    {currentUser.isRoot() ? <AdminPanelSettings /> : <Person />}
                    <HSpacer small />
                    <Text style={{ ...(asUser === currentUser.id ? { color: `tomato` } : { cursor: `pointer` }) }}>
                      {currentUser.email}
                    </Text>
                  </MenuItem>
                ))}
              </Grid>
              <Grid
                container
                item
                style={{ position: `absolute`, bottom: 0, height: `38px`, width: `100%` }}
                justifyContent="center"
              >
                <RoutalSearchInput
                  inputContainerStyles={{
                    width: `100%`,
                    margin: `0 8px`,
                  }}
                  fieldValue={searchText}
                  onChange={debounce((text: string) => {
                    setSearchText(text.trim());
                  }, 300)}
                  autoFocus
                  searchLive
                />
              </Grid>
            </Grid>
          </Menu>
        </>
      )}
    </>
  );
};
